import { ReactComponent as BackgroundSVG } from './Background.svg';
import styles from './BookDemo.module.css';
import { ReactComponent as Arrow } from '../../../components/svg/Arrow.svg';

export const BookDemo = () => {
  return (
    <div className={styles.container}>
      <BackgroundSVG className={styles.background} />
      <h4 className={styles.title}>Want to find out more? Get in touch.</h4>
      <p className={styles.text}>
        We’re always happy to chat. Book a time that suits you and one of our
        team will give you a ring.
      </p>
      <a
        href="https://share.hsforms.com/12VUdA9mYQqSR_34KvL5h6Q3rrot"
        className={styles.link}
      >
        <span>BOOK A CALL</span>
        <Arrow className={styles.arrow} />
      </a>
    </div>
  );
};
